<template>
    <div class="footer">
        <div class="container text-left text-white">
            <div class="title">{{ $t('subscribe_news_offers')}}</div>
            <b-row class="d-flex mt-3">
                <b-col cols="12" md="3">             
                    <label>{{ $t('name')}}</label>
                    <b-input aria-placeholder="Enter your company or personal brand name"></b-input>             
                </b-col>
                <b-col cols="12" md="3">
                    <label>{{ $t('email')}}</label>
                    <b-input></b-input>
                </b-col>
                <b-col cols="12" md="3" class="d-flex align-items-end mt-3">               
                    <b-button class="footer-button">
                        <img src="../assets/images/footer/loading.png" class="mx-2">
                        {{ $t('subscribe')}}
                        <img src="../assets/images/footer/arrow_right.png" class="mx-1">
                    </b-button>
                </b-col>
            </b-row>
            <div class="footer-text">
                <div class="mt-3" v-html="$t('footer_text1')">
                   
                </div>
                <div class="mt-3" v-html="$t('footer_text2')">
               
                </div>
                <div class="mt-3" v-html="$t('footer_text3')">
                </div>
            </div>
            <hr>
            <div class="coptright">
                {{ $t('copyright2') }}
            </div>
    
        </div>
    </div>
</template>
<script>
export default{
     name: 'Footer',
}
</script>